import { type SxProps, type Theme } from '@mui/material'

// Design tokens from the Figma "Prototypes" / Caregiver Portal frames (Service Details documents, Document Upload)
export const colors = {
  textPrimary: '#222024',
  textTertiary: '#514F53',
  cardBackground: '#ECEDEF',
  border: '#E7E7E7',
  purple: '#7136BC',
  chip: '#722A82',
  red: '#BC3656',
  redLight: '#FEF0F3',
  green: '#0E8476',
  greenLight: '#E7F3F2',
  teal: '#4DA4A4',
  tealLight: '#DBEDED',
  checkbox: '#02AED9'
}

/** Outlined pill used for Upload a File / Take Photo / Cancel */
export const outlinedPill: SxProps<Theme> = {
  border: `1px solid ${colors.purple}`,
  borderRadius: '20px',
  color: colors.purple,
  fontSize: 14,
  fontWeight: 600,
  px: '28px',
  py: '12px',
  lineHeight: 'normal',
  '&:hover': { border: `1px solid ${colors.purple}`, backgroundColor: 'rgba(113, 54, 188, 0.06)' }
}

/** White rounded input box used for the income amount and year (matches the Document Upload frame) */
export const whiteInput: SxProps<Theme> = {
  backgroundColor: 'white',
  borderRadius: '10px',
  fontSize: 14,
  color: colors.textPrimary,
  '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.border, borderRadius: '10px' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.purple },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: colors.purple, borderWidth: 1 }
}
